import React from 'react'
import {Icon, Loading, Modal} from '@therms/atalaya'
import {NoContentPlaceholder, useRPC} from '@therms/react-modules'
import {RPCDocs, RPCs} from '@therms/rpc-gateway'
import {LocationTaskCompletionListCard} from '@src/modules/Locations/components/LocationTaskCompletionListCard.tsx'
import {MdChecklist} from 'react-icons/md'

interface LocationTaskHistoryModalProps {
  closeHandler: () => void
  locationTaskId: string
}

export function LocationTaskHistoryModal({
  closeHandler,
  locationTaskId,
}: LocationTaskHistoryModalProps) {
  const taskRpc = useRPC<
    RPCDocs.Locations.GetLocationTask.v1.Args,
    RPCDocs.Locations.GetLocationTask.v1.Data
  >(RPCs.Locations.GetLocationTask.v1, {
    id: locationTaskId,
  })
  const completionsRpc = useRPC<
    RPCDocs.Locations.GetLocationTaskCompletions.v1.Args,
    RPCDocs.Locations.GetLocationTaskCompletions.v1.Data
  >(RPCs.Locations.GetLocationTaskCompletions.v1, {
    locationTaskIds: [locationTaskId],
  })

  return (
    <Modal
      closeHandler={closeHandler}
      header={taskRpc.data?.locationTask.title}
      escPressClose
    >
      {(taskRpc.isCalling || completionsRpc.isCalling) &&
        !completionsRpc.data?.locationTaskCompletions && <Loading overlay />}

      {!!completionsRpc.data?.locationTaskCompletions && (
        <div className="space-y-xs">
          {completionsRpc.data.locationTaskCompletions.map((completion) => (
            <div className="bg-surface-subtle" key={completion.id}>
              <LocationTaskCompletionListCard
                hideDetails
                locationTaskCompletion={completion}
              />
            </div>
          ))}
        </div>
      )}

      {!completionsRpc.isCalling &&
        !completionsRpc.data?.locationTaskCompletions?.length && (
          <NoContentPlaceholder icon={<Icon Icon={MdChecklist} size="xl" />}>
            No Task History
          </NoContentPlaceholder>
        )}
    </Modal>
  )
}
